// extracted by mini-css-extract-plugin
export default {"container":"PortfolioSection_container__KYzaZ","navigation_trick_element":"PortfolioSection_navigation_trick_element__PqJwy","heading":"PortfolioSection_heading__vVmtb"};